import { render } from "./ThePicturesSwiper.vue?vue&type=template&id=991351ca"
import script from "./ThePicturesSwiper.vue?vue&type=script&lang=js"
export * from "./ThePicturesSwiper.vue?vue&type=script&lang=js"

import "./ThePicturesSwiper.vue?vue&type=style&index=0&id=991351ca&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__